export function homeForGroups(groups = []) {
  if (groups.includes('Delivery')) return '/driver';
  if (groups.includes('Admin') || groups.includes('Ops')) return '/';
  return null;
}

/** POS amend/edit APIs are Ops/Admin only (Customer/Delivery → 403 server-side). */
export function canAmendPos(groups = []) {
  return groups.includes('Admin') || groups.includes('Ops');
}
